import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import styles from './ReportHome.module.css';
import BlockButton from '@users/BlockButton';

const ReportedItem = ({ reportItem }) => {
  const reportSection = (reports) => {
    return reports.map((report) => {
      return (
        <div key={report.id} className={styles.individual_report_container}>
          <div className={styles.reason_text}>
            <span style={{ fontWeight: 'bold'}}>Reason:</span> {report.reason}
          </div>
          <div className={styles.reason_text}>
            <span style={{ fontWeight: 'bold'}}>Content:</span> {report.content}
          </div>

          <div className={styles.reported_on}>
            {report.reported_on}
          </div>
        </div>
      );
    });
  }

  const reportedEntries = () => {
    if (reportItem.reports.reported_entries.length > 0) {
      return (
        <div className={styles.report_section_container}>
          <div className={styles.section_header}>
            REPORTED ENTRIES
          </div>
          {reportSection(reportItem.reports.reported_entries)}
        </div>
      );
    }
  };

  const reportedComments = () => {
    if (reportItem.reports.reported_comments.length > 0) {
      return (
        <div className={styles.report_section_container}>
          <div className={styles.section_header}>
            REPORTED COMMENTS
          </div>
          {reportSection(reportItem.reports.reported_comments)}
        </div>
      );
    }
  };

  const reportedReviews = () => {
    if (reportItem.reports.reported_reviews.length > 0) {
      return (
        <div className={styles.report_section_container}>
          <div className={styles.section_header}>
            REPORTED REVIEWS
          </div>
          {reportSection(reportItem.reports.reported_reviews)}
        </div>
      );
    }
  };

  return (
    <div className={styles.report_object_container}>
      <div className={styles.top_container}>
        <div style={{ fontWeight: 'bold'}}>
          Reported User: {reportItem.full_name} <span style={{ fontWeight: 'normal'}}>(@{reportItem.username})</span>
          <div style={{ fontWeight :'normal', marginTop: 0, fontSize: 14 }}>Reported count: {reportItem.reported_count}</div>
        </div>

        <BlockButton user={reportItem} />
      </div>

      {reportedEntries()}
      {reportedComments()}
      {reportedReviews()}
    </div>
  );
};

export default ReportedItem;
